const en_supplychain_do = {
    "": "Delivery Order",

    label: {
        from: "Shipped from",
    },

    error: {
        create: "Failed to create DO",
        edit: "Failed to update DO",
    },

    success: {
        create: "DO created successfully",
        edit: "DO updated successfully",
    },
}

export default en_supplychain_do;